import * as React from 'react';
import {action, observable} from 'mobx';
import { observer } from 'mobx-react';
import {UserAvatarEditor} from "components/account/widgets/UserAvatarEditor";
import UserDataSource from "data/UserDataSource";
import {SignupInput} from "components/signup/SignupInput";
import InvalidBubble from "components/signup/shared/InvalidBubble";
import {UIState} from "data/UIState";
import {createRef} from "react";
import {ButtonAction} from "../widgets/ButtonAction";
import {Alert} from "../../data/Alert";
import {handleSpacePressed} from "utils";




interface Props {

  continue:()=>void;
  pleaseWait:boolean;
}

@observer
export class Step3Profile extends React.Component<Props> {
  h1Ref;
  avatarBlobData:any;
  @observable existingAvatar:string|null = null;
  @observable nickname = '';
  @observable nicknameInvalid = false;

  constructor(props) {
    super(props);
    this.h1Ref = createRef();
  }

  componentDidMount() {
    if(this.h1Ref &&this.h1Ref.current) {
      this.h1Ref.current.focus();
    }
  }


  setAvatarBlobData = (data) => {
    this.avatarBlobData = data;
    if(null===data) {
      this.existingAvatar = null;
    }
  }



  continue = () => {

    let nickname = this.nickname;
    if(nickname) {
      nickname = nickname.trim();
      if(nickname.length<3) {
        Alert.alert(UserDataSource.constants.NICKNAME_LENGTH_REQUIREMENTS)
        this.nicknameInvalid = true;
        return;
      }
      if(!UserDataSource.utils.isNicknameValid(nickname)) {
        Alert.alert(UserDataSource.constants.NICKNAME_CHAR_REQUIREMENTS)
        this.nicknameInvalid = true;
        return;
      }
      this.nicknameInvalid = false;
    } else {
      nickname = '';
      this.nicknameInvalid = false;
    }

    let profileData = {
      nickname: nickname,
      avatarBlobData: this.avatarBlobData,
      avatarURL: '',
    };

    UserDataSource.saveUserProfile(UIState.user, profileData)
      .then((result:any)=>{
        if(undefined == result.nickname && nickname.length>0) {
          Alert.alert('The nickname \"'+nickname+'\" is already taken by another user. Please enter a different nickname.');
        } else {
          // UIState.alert('Success! Nice work señor!');
          this.props.continue();
        }
      })
      .catch(()=>{
        Alert.alert('Failed to save account. Please make sure that your Internet connection is stable and try again. If this fails, reload your browser and log in to Wellness Concepts with your new account. You can set your avatar and nickname once logged in.');
      });

  }

  @action handleNickNameChange = (e)=>{
    const nickname = e.target.value;
    if(!UserDataSource.utils.doesNicknameHaveIllegalCharSequence(nickname)) {
      this.nickname = nickname;
    }
  }

  render() {

    return (
      <>
      <div className="profile">
        <div className="innerForm">
          <h1 ref={this.h1Ref} className={"level1"}>Welcome, {UIState.user.firstName}! Customize your profile.</h1>
          <div className={"form-element email"}>
            <label htmlFor={"nickname"}>Nickname</label>
            <p className="hint">If you add a nickname, it will be displayed instead of your name near your comments. You can use letters, numbers, underscores and periods.</p>
            <div className="input-anti-pad">
              <input
                  id={"nickname"}
                type={'text'}
                value={this.nickname}
                onChange={this.handleNickNameChange}
                placeholder={'enter a nickname'}
                disabled={this.props.pleaseWait}
                aria-label={'nickname'}
                aria-invalid={this.nicknameInvalid}
                maxLength={20}
              />
            </div>
            <InvalidBubble label={'A valid nickname is required'} show={this.nicknameInvalid} />
          </div>
          <div className={"form-element email"}>
            <label>Avatar</label>
            <p className="hint">
              Upload a photo or avatar for your account. It will be displayed
              near any comments that you make instead of your initials, or the first
              letter of your nickname.</p>
            <div className="input-anti-pad">
              <UserAvatarEditor
                existingAvatarURL={UIState.user.avatarURL}
                setData={this.setAvatarBlobData}
                hideTitleAndDescription
              />
            </div>
          </div>
        </div>
      </div>
      <div className={'form-element tight'}>
        {/*<ButtonAction onClick={this.continue} className={"cta-button noselect"}>Continue</ButtonAction>*/}
        <a tabIndex={0} className="cta-button noselect three-band-focus"
           onClick={this.continue}
           onKeyDown={(e)=>{ handleSpacePressed(e, this.continue);}}
        >Continue</a>
      </div>
    </>
    );


  }
}

